export default "__VITE_ASSET__DtPCYPJk__"